import { useState } from "react";
import { Box, Skeleton, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CountryBar } from "src/components/country-bar";
import { useCountryData } from "src/components/visibility";
import { useSelectedCountry } from "src/components/data-grid/activations/hooks/useSelectedCountry";
import { useCurrentWorkspace } from "src/context/reducers/app-settings";
import { NumberFormatter } from "src/utils/format-number";
import CreateExperimentModal from "./create-experiment-modal";
import ExperimentsTable from "./experiments-table";
import { tr } from "./i18n";

export default function BidStratTesting() {
    // Re-renders the page in the new language when it changes
    useTranslation();
    const workspace: any = useCurrentWorkspace();
    const { countriesData, isLoading } = useCountryData();
    // Raw BigQuery region_name: no "All" tab, an experiment lives in one region
    const { selectedCountry, setSelectedCountry } = useSelectedCountry(countriesData);
    const [createOpen, setCreateOpen] = useState(false);

    const currency = (workspace?.currency || "EUR").toUpperCase();
    const locale = NumberFormatter.getCurrentLocale();
    const isReady = !!workspace && !!selectedCountry;

    const tableProps = {
        workspaceId: workspace?.id,
        regionName: selectedCountry as string,
        currency,
        locale,
        onCreate: () => setCreateOpen(true),
    };

    return (
        <Box>
            <CountryBar
                loading={isLoading}
                countries={countriesData}
                selectedCountry={selectedCountry}
                onCountryChange={setSelectedCountry}
                indicator="radio"
                stickyTop={107}
                backgroundColor="background.paper"
                topGap={20}
                contentPaddingX="24px"
            />

            <Box px="24px" mt="24px" pb={4}>
                {!isReady ? (
                    <Skeleton variant="rectangular" height={320} sx={{ borderRadius: "12px" }} />
                ) : (
                    <Stack spacing="20px">
                        <ExperimentsTable status="running" title={tr("page.ongoing")} {...tableProps} />
                        <ExperimentsTable status="completed" title={tr("page.completed")} {...tableProps} />
                        <CreateExperimentModal
                            open={createOpen}
                            onClose={() => setCreateOpen(false)}
                            workspaceId={workspace.id}
                            regionName={selectedCountry as string}
                        />
                    </Stack>
                )}
            </Box>
        </Box>
    );
}
